'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _modifiers = require('../../utils/modifiers');

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _Li = require('./Li');

var _Li2 = _interopRequireDefault(_Li);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function SelectableLi(_ref) {
  var modifiers = _ref.modifiers,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['modifiers', 'children']);

  return _react2.default.createElement(
    _Li2.default,
    { modifiers: (0, _modifiers.modifiersForComponent)(modifiers, _Li2.default) },
    _react2.default.createElement(
      _Button2.default,
      _extends({ modifiers: (0, _modifiers.modifiersForComponent)(modifiers, _Button2.default) }, rest),
      children
    )
  );
}

SelectableLi.propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string),
  children: _propTypes2.default.node.isRequired
};

SelectableLi.defaultProps = {
  modifiers: []
};

exports.default = SelectableLi;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/elements/SelectableLi/index.js
// module id = 716
// module chunks = 2